// src/pages/SubcodonProfile/hooks/useBatchSettings.js
import { useState, useCallback } from "react";

const defaultBatchSettings = {
  transcriptList: "ENST00000316292",
  csvCheck: true,
  htmlCheck: false,
};

export const useBatchSettings = () => {
  const [batchSettings, setBatchSettings] = useState(defaultBatchSettings);

  const updateBatchSetting = useCallback((key, value) => {
    setBatchSettings((prev) => ({
      ...prev,
      [key]: value,
    }));
  }, []);

  const updateMultipleBatchSettings = useCallback((newSettings) => {
    setBatchSettings((prev) => ({ ...prev, ...newSettings }));
  }, []);

  const resetBatchSettings = useCallback(() => {
    setBatchSettings(defaultBatchSettings);
  }, []);

  const validateBatchSettings = useCallback(() => {
    const errors = [];

    // Ensure at least one output format is selected
    if (!batchSettings.csvCheck && !batchSettings.htmlCheck) {
      errors.push("Please select at least one output format (CSV or HTML)");
    }

    return {
      isValid: errors.length === 0,
      errors,
    };
  }, [batchSettings]);

  return {
    batchSettings,
    updateBatchSetting,
    updateMultipleBatchSettings,
    resetBatchSettings,
    validateBatchSettings,
  };
};

export default useBatchSettings;
